module.exports = "images/pink.b788057fbc8c05e292cbbb6dc24c372d.png";